import axios from "../http-client/axios";
import { AUTH_URL } from "../urls/base-urls";
import {
  APP_AUTORIZATION_USER,
  APP_AUTORIZATION,
} from "../urls/enviroment-variables";

export async function requestLogin(user, token) {
  const clientCredentialsBase64 = btoa(
    `${APP_AUTORIZATION_USER}:${APP_AUTORIZATION}`
  );
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  myHeaders.append("Authorization", `Basic ${clientCredentialsBase64}`);
  myHeaders.append("token-captcha", token);

  const urlencoded = new URLSearchParams();
  urlencoded.append("grant_type", "password");
  urlencoded.append("username", user?.login);
  urlencoded.append("password", user?.password);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  const response = await fetch(`${AUTH_URL}/oauth/token`, requestOptions);

  if (!response.ok) {
    const errorData = await response.json();

    throw { response: { data: errorData } };
  }

  const data = await response.json();

  return data;
}

export async function requestLoginInspect(crm) {
  const resp = await axios({
    url: `${AUTH_URL}/login/inspecionation?crm=${crm}`,
    method: "post",
    data: {},
  });
  return resp.data;
}
